/*eslint no-magic-numbers: 0*/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getColor, getCircleColor } from "../../../../../../store/helpers/uiHelper";
import gaugeLow from "../../../../../../assets/images/icons/gauge_low.svg";
import gaugeMed from "../../../../../../assets/images/icons/gauge_med.svg";
import gaugeHigh from "../../../../../../assets/images/icons/gauge_high.svg";

//scss
import "./StressIndexScore.scss";
import "../../../../scss/circle.scss";

import StressCurve from "../StressCurve";
import StressGraph from "../StressGraph";

class StressIndexScore extends Component {
  renderImage(score) {
    if (score) {
      if (score > 0 && score <= 1.66) return gaugeLow;
      if (score > 1.66 && score <= 4.98) return gaugeMed;
      if (score > 4.98 && score <= 6.64) return gaugeHigh;
      if (score > 6.64 && score <= 8.3) return gaugeMed;
      if (score > 8.3) return gaugeLow;
    }
  }

  render() {
    const { questionAverages, stressComments, isTeam360 } = this.props;

    let paragraphs = [];
    if (isTeam360) {
      paragraphs.push(
        "Your team has already scored its stress level which can be seen on the left below. The curve on the right-hand side shows how your stress levels are viewed by your stakeholders. Clearly, they can only view this from outside of the team and how they interest with your team members.",
        "Ideally, you’d like both your own scores and those of your stakeholders to match and be within the green sectors. If there is a disconnect between graphs, then it will give you a good opportunity to discuss the overall scores with your stakeholders. If the perceived stress is too high, then work with then to understand how they can be reduced to improve stakeholder relationships and productivity."
      );
    } else {
      stressComments &&
        stressComments.comments.map((comment) => {
          return paragraphs.push(comment);
        });
    }

    return (
      <Fragment>
        <div className="stress-index">
          <div className="stress-index__container">
            {paragraphs && paragraphs.length > 0
              ? paragraphs.map((paragraph, index) => {
                  return (
                    <h6 key={index} className="mt-2">
                      {paragraph}
                    </h6>
                  );
                })
              : null}
            <StressGraph />
          </div>
          {questionAverages && (
            <div className="stress-index-container__values-wrapper">
              <div className="stress-index__details-gauge">
                <img className="gauge" src={this.renderImage(questionAverages.si)} alt="gauge" />
              </div>

              <div className="stress-index__details__info-container">
                <div className="stress-index__details__info-container-details-blue">
                  <span>TL</span>
                </div>
                <div className="stress-index__details__info-container-details">
                  <span
                    className="stress-index__details__info-container-details-index"
                    style={{
                      color: getColor(questionAverages.si, true),
                    }}
                  >
                    si
                  </span>
                </div>
              </div>
              <div className="stress-index__details-progress">
                <div
                  className={`c100 p${questionAverages.si * 10} ${getCircleColor(
                    questionAverages.si,
                    true
                  )}`}
                >
                  <span>{questionAverages.si}</span>
                  <div className="slice">
                    <div className="bar" />
                    <div className="fill" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <StressCurve />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  questionAverages: state.reports.questionAverages,
  stressComments: state.reports.stressComments,
  isTeam360: state.reports.reportStatus.is_team_360,
});

StressIndexScore.propTypes = {
  questionAverages: PropTypes.object,
  stressComments: PropTypes.object,
  radius: PropTypes.number,
  stroke: PropTypes.number,
  strokeDashoffset: PropTypes.number,
  progress: PropTypes.number,
  isTeam360: PropTypes.bool,
};

export default connect(mapStateToProps, null)(StressIndexScore);
